import { Injectable, inject } from '@angular/core';
import { Either, Left, Right } from 'purify-ts';
import { AuthRepositoryFailure } from '../../../domain/auth/failure';
import { IAuthRepository } from '../../../domain/auth/i-auth-repository';
import { AuthenticatedUser } from '../../../domain/auth/types';
import { isUnauthenticatedError } from '../../../util/http-error';
import { ApiResponse } from '../../../util/type';
import { IHttpClient } from '../../services/httpClient/interface';

@Injectable({
  providedIn: 'root',
})
export class RealAuthRepository implements IAuthRepository {
  private httpClient = inject(IHttpClient);

  public async getMe(): Promise<Either<AuthRepositoryFailure, AuthenticatedUser>> {
    try {
      const { body } = await this.httpClient.get<ApiResponse<AuthenticatedUser>>('/auth/me');
      return Right(body.data);
    } catch (error) {
      return Left(
        isUnauthenticatedError(error)
          ? AuthRepositoryFailure.unauthenticated()
          : AuthRepositoryFailure.fromApiError({
              error,
              fallbackMessage: 'Não foi possível carregar os dados do seu usuário.',
            })
      );
    }
  }
}
